import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';
import { sessionActions } from 'src/app/store/actions';
import { sessionSelectors } from 'src/app/store/selectors';
import { AppState } from '../models/app-state.models';
/* import { EndpointName } from '../models/endpoints.models'; */
import { APIService } from '../services/api.service';
import { PopupService } from '../services/popup.service';
import { SessionService } from '../services/session.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    private window;
    private authToken = null;
    private isLogged = false;
    private isRefreshing = false;

    private refreshTokenSubject$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private refreshCookieName = 'doc_plus_refresh';

    constructor(
        private store: Store<AppState>,
        private apiService: APIService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private sessionService:SessionService
    ) {
        this.window = getWindow();
        this.store.select(sessionSelectors.selectAuthToken)
            .subscribe(t => {
                this.authToken=t
            });
/*         this.store.select(sessionSelectors.selectLoginStatus)
            .subscribe(s => this.isLogged = s);

            sessionService.authToken$.subscribe(token=>{
                //console.warn("token value")
                this.authToken=token
            }) */
           if(localStorage.getItem('token')){
            this.authToken=localStorage.getItem('token')
           }
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (req.headers.get('disableauthintercept') !== null) {
            return next.handle(req);
        }

        req = this.addToken(req, this.authToken);

        return next.handle(req).pipe(
            tap(result => { }),
            catchError(error => {

                // refresh token and logout API's don't need refresh token validation
                if (req.url.includes('refresh') || req.url.includes('logout')) {
                    this.isRefreshing = false;
                    return throwError(error);
                }

                // login POST API's don't need refresh token validation
                if (req.url.includes('login') && req.method === 'POST') {
                    this.isRefreshing = false;
                    return throwError(error);
                }
                console.log(error);

                if (error instanceof HttpErrorResponse && error.status === 403) {
                    if (!this.isRefreshing) {
                        this.isRefreshing = true;
                        this.refreshTokenSubject$.next(null);

                        /* return this.apiService.post(EndpointName.refreshToken, {})
                            .pipe(
                                switchMap((response: any) => {
                                    this.isRefreshing = false;
                                    this.refreshTokenSubject$.next(response.data.token);
                                    this.store.dispatch(sessionActions.updateAuthToken({ token: response.data.token }));
                                    return next.handle(this.addToken(req, response.data.token));
                                })
                            ); */
                    } else {
                        return this.refreshTokenSubject$.pipe(
                            filter(token => token !== null),
                            take(1),
                            switchMap(token => {
                                return next.handle(this.addToken(req, token));
                            })
                        );
                    }
                } else if (error.status === 401 && this.isLogged === null) {
                    if (this.router.url === '/' || this.router.url.includes('/d/') || this.router.url.includes('/p/')) {
                        // do nothing
                    } else if (this.router.url.includes('consultation')) {
                        const parsedUrl = new URL(window.location.href)
                        const token = parsedUrl.searchParams.get('token');
                        if (token !== null) {
                            // Get the refresh token
                            document.cookie = this.refreshCookieName + '=' + token + '; path=/';
                            this.isRefreshing = true;

                           /*  return this.apiService.post(EndpointName.refreshToken, {})
                                .pipe(
                                    switchMap((response: any) => {
                                        this.isRefreshing = false;
                                        this.refreshTokenSubject$.next(response.data.token);
                                        this.store.dispatch(sessionActions.updateAuthToken({ token: response.data.token }));
                                        return next.handle(this.addToken(req, response.data.token));
                                    })
                                ); */
                        }
                        console.log('Consultation session')
                    } else {
                        console.log(`Error on token`, this.router.url);
                        if(this.router.url.includes('/u/')) return;
                        this.router.navigate(['/auth', 'login']);
                        this.store.dispatch(sessionActions.sessionLoggedOut())
                    }
                }

                return throwError(error);
            })
        );
    }

    private addToken(req: HttpRequest<any>, token) {
        return req.clone({
            withCredentials: true,
            setHeaders: {
                'Authorization': `Bearer ${token}`
            }
        });
    }

    // private addForwardedHeader(req: HttpRequest<any>, token) {
    //     return req.clone({
    //         setHeaders: {
    //             'Authorization': `Bearer ${token}`
    //         }
    //     });
    // }
}

function getWindow(): any {
    return window;
}
